import * as $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.min'
import 'metismenu';
import 'jquery-slimscroll';

import Raphael from 'raphael/raphael'
global.Raphael = Raphael;
